import {
    lazySubscribe,
    lazyUnsubscribe,
    NotificationSubscription,
    lazyGetChannelId,
} from 'owa-notification';
import type SubscriptionParameters from 'owa-service/lib/contract/SubscriptionParameters';
import unreadNotificationHandler from './unreadNotificationHandler';

const folderIdToNotificationMap: { [id: string]: NotificationSubscription } = {};

export function createRowNotificationSubscription(folderId: string) {
    // if subscription already exists, do nothing
    if (!folderIdToNotificationMap.hasOwnProperty(folderId)) {
        lazyGetChannelId.import().then(getChannelId => {
            const subscriptionParameters: SubscriptionParameters = {
                NotificationType: 'RowNotification',
                FolderId: folderId,
                IsConversation: true,
                ChannelId: getChannelId(),
            };
            const subscription: NotificationSubscription = {
                subscriptionId: folderId,
                requiresExplicitSubscribe: true,
                subscriptionParameters: subscriptionParameters,
            };

            // Double check the map before and after making the async call to subscribe
            if (!folderIdToNotificationMap.hasOwnProperty(folderId)) {
                lazySubscribe.importAndExecute(subscription, unreadNotificationHandler);
                if (!folderIdToNotificationMap.hasOwnProperty(folderId)) {
                    folderIdToNotificationMap[folderId] = subscription;
                }
            }
        });
    }
}

export async function unsubscribeFromRowNotifications() {
    const unsubscribe = await lazyUnsubscribe.import();

    Object.keys(folderIdToNotificationMap).forEach(folderId => {
        unsubscribe(folderIdToNotificationMap[folderId], unreadNotificationHandler);
        delete folderIdToNotificationMap[folderId];
    });
}
